<template>
    <CompassDialog
        :visible.sync="visible"
        :title="$t.__('ai.CustomTagsAIModal.title_dialog')"
        class="custom-tags-ai-modal"
        :closeOnClickOverlay="false"
        @closed="handleClose"
    >
        <template #default>
            <CompassFormItem
                :label="$t.__('ai.CustomTagsAIModal.form_item_name_tags_ai')"
                :error="errorLabelCustomTagAIName"
                required
                :requiredLabel="$t.__('common.labels.required')"
                class="custom-tags-ai-modal__name"
            >
                <CompassInput
                    ref="nameInput"
                    v-model="customTagAIName"
                    :error="!!errorLabelCustomTagAIName"
                    :placeholder="$t.__('ai.CustomTagsAIModal.placeholder_name_tags_ai')"
                />
            </CompassFormItem>
            <RichText
                v-model="customTagAIPrompt"
                :formitem="formItemRichText"
                :placeholder="$t.__('ai.CustomTagsAIModal.placeholder_prompt_tags_ai')"
                :options="optionsRichText"
            />
        </template>
        <template #footer>
            <div class="custom-tags-ai-modal__footer">
                <CompassButton
                    type="secondary"
                    :label="$t.__('common.actions.cancel')"
                    @click="handleClose"
                />
                <ButtonAI
                    :label="$t.__('common.actions.validate')"
                    size="medium"
                    @click="handleValidate"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import ButtonAI from 'vcomponents/common/ai/ButtonAI.vue';
const RichText = () => import('vcomponents/richtext/RichText.vue');
import generateHash from 'Helpers/hashGenerator.js';

export default {
    components: {
        ButtonAI,
        RichText,
    },
    props: {
        data: {
            type: Object,
            default: () => ({
                label: '',
                prompt: '',
            }),
        },
        editor: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            visible: true,
            optionsRichText: ['CustomTagsAndFields'],
            customTagAIName: '',
            customTagAIPrompt: '',
            errorLabelCustomTagAIName: '',
            errorLabelCustomTagAIPrompt: '',
        };
    },
    computed: {
        formItemRichText() {
            return {
                label: this.$t.__('ai.CustomTagsAIModal.form_item_prompt_tags_ai'),
                error: this.errorLabelCustomTagAIPrompt,
                required: true,
                requiredLabel: this.$t.__('common.labels.required'),
            };
        },
    },
    watch: {
        customTagAIName(newValue) {
            this.customTagAIName = newValue.replace(/"/g, "''");
        },
        customTagAIPrompt(newValue) {
            this.customTagAIPrompt = newValue.replace(/"(?![^<]*>)/g, "''");
        },
    },
    created() {
        this.customTagAIName = this.data?.label ?? '';
        this.customTagAIPrompt = this.data?.prompt ?? '';
    },
    mounted() {
        setTimeout(() => {
            this.$refs.nameInput.setFocus();
        }, 0);
    },
    destroyed() {
        this.customTagAIName = '';
        this.customTagAIPrompt = '';
    },
    methods: {
        checkForm() {
            let validForm = true;
            if (!this.customTagAIName) {
                validForm = false;
                this.errorLabelCustomTagAIName = this.$t.__(
                    'ai.CustomTagsAIModal.error_label_name_tags_ai',
                );
            } else {
                this.errorLabelCustomTagAIName = '';
            }
            if (!this.customTagAIPrompt) {
                validForm = false;
                this.errorLabelCustomTagAIPrompt = this.$t.__(
                    'ai.CustomTagsAIModal.error_label_prompt_tags_ai',
                );
            } else {
                this.errorLabelCustomTagAIPrompt = '';
            }
            return validForm;
        },
        handleValidate() {
            if (this.checkForm()) {
                this.handleClose();
                const option = {
                    editor: this.editor,
                    label: this.customTagAIName.replace('}', ''),
                    prompt: this.customTagAIPrompt,
                    hash: this.data ? this.data.hash : generateHash(),
                };
                if (this.data) {
                    EventBus.emit('customTagsAI:updateTagAI', option);
                } else {
                    this.$emit('addTagAI', option);
                }
            }
        },
        handleClose() {
            this.showModal = false;
            this.$emit('close');
            EventBus.emit('customTagsAndFieldsRichText:closeModal');
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-tags-ai-modal {
    &__name {
        margin: 0 0 var(--spacing-3);
    }
    &__footer {
        display: flex;
        justify-content: flex-end;
        gap: var(--spacing-3);
        padding: var(--spacing-4) var(--spacing-5) var(--spacing-5);
    }
}
</style>
